"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCells = void 0;
const currency_label_1 = require("@components/currency-label");
const expandable_grid_1 = require("@shared-modules/components/expandable-grid");
const object_1 = require("@utils/object");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const getCells = (translator, commonTranslator, scannerUrl) => [
    {
        id: "event",
        title: translator("eventColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ event }) => react_1.default.createElement("b", null, translator(event + "EventLabel")),
    },
    {
        id: "price",
        title: translator("priceColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.Number,
        render: ({ price, paymentTokenAddress }) => price && paymentTokenAddress ? (react_1.default.createElement(currency_label_1.CurrencyLabel, { showIcon: false, amount: price, tokenAddress: paymentTokenAddress })) : ("-"),
    },
    {
        id: "from",
        title: translator("fromColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ from }) => from ? (react_1.default.createElement(react_router_dom_1.Link, { className: "g-link", to: `/profile/${from}` }, (0, object_1.formatAddress)(from))) : ("-"),
    },
    {
        id: "to",
        title: translator("toColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ to }) => to ? (react_1.default.createElement(react_router_dom_1.Link, { className: "g-link", to: `/profile/${to}` }, (0, object_1.formatAddress)(to))) : ("-"),
    },
    {
        id: "date",
        title: translator("dateColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ date }) => {
            const time = (0, object_1.sliceDuration)((new Date().getTime() - date) / 1000, [
                commonTranslator("time.yearShortLabel"),
                commonTranslator("time.monthShortLabel"),
                commonTranslator("time.dayShortLabel"),
                commonTranslator("time.hourShortLabel"),
                commonTranslator("time.minuteShortLabel"),
                commonTranslator("time.secondShortLabel"),
            ])
                .slice(0, 2)
                .join(" ");
            return commonTranslator("time.timeAgo", { time });
        },
    },
    {
        id: "tx",
        title: translator("txColumnLabel"),
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ txHash }) => (react_1.default.createElement("a", { className: "g-link", target: "_blank", rel: "noreferrer", href: scannerUrl + "/tx/" + txHash }, translator("scannerLinkLabel"))),
    },
];
exports.getCells = getCells;
